export const createPhase = `
    mutation createPhase($input: CreatePhaseInput!) {
        createPhase(input:$input) {
            id
            playbookId
            name
            displayName
            description
            position
            createdByUsername
            created
    }
}`;

export const updatePhase = `
    mutation updatePhase($input: UpdatePhaseInput!) {
        updatePhase(input:$input){
            id
            playbookId
            name
            displayName
            description
            position
            createdByUsername
            created
            updated
        }
}`;

export const deletePhase = `
    mutation deletePhase($input: DeletePhaseInput!) {
        deletePhase(input:$input) {
            id
        }
}`;
